import React from 'react';
import { reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

import { AERIES_MAPPINGS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import {
  AeriesMapOptions,
  AeriesFieldEnum,
  AeriesMapConfig,
} from 'Common/Constants/SISIntegration';
import SISFields from 'Common/SISFields';

const AeriesMappingStepFormContainer = (props) => {
  const {
    siteOptions,
    gradeOptions,
    languageOptions,
    siteSourceOptions,
  } = props;

  return (
    <Form name={AERIES_MAPPINGS_FORM_NAME}>
      <TitledCard title={'Field Mappings'}>
        <SISFields
          integrationMapOptions={AeriesMapOptions}
          integrationMapConfig={AeriesMapConfig}
          integrationMapData={{
            [AeriesFieldEnum.SiteMapping]: siteOptions,
            [AeriesFieldEnum.GradeMapping]: gradeOptions,
            [AeriesFieldEnum.LanguageMapping]: languageOptions,
          }}
          integrationSourceOptions={{
            [AeriesFieldEnum.SiteMapping]: siteSourceOptions,
          }}
        />
      </TitledCard>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  //for each map field
  AeriesMapOptions.forEach((field) => {
    if (!values[field.key]) {
      errors[field.key] = 'Please select an option.';
    }
  });

  return errors;
};

export const AeriesMappingStepForm = reduxForm({
  form: AERIES_MAPPINGS_FORM_NAME,
  validate,
  enableReinitialize: true,
})(AeriesMappingStepFormContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesMappingStep/AeriesMappingForm.js